import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import Loader from './app/shared/components/Loader';

function getVersion() {
    return process.env.REACT_APP_CLIENT_VERSION || 'dev';
}

axios.defaults.headers.common['EconomicClient'] = `client; ${getVersion()}`;

const Economic = React.lazy(() => import(/* webpackChunkName: "application" */ './app'));
const External = React.lazy(() => import(/* webpackChunkName: "external" */ './external'));

const Application = () => {
    return (
        <React.Suspense fallback={<Loader />}>
            <BrowserRouter>
                <Switch>
                    <Route path="/external" component={External} />
                    <Route component={Economic} />
                </Switch>
            </BrowserRouter>
        </React.Suspense>
    );
};

ReactDOM.render(<Application />, document.getElementById('root'));
